module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/clock-5e62e9e699b7fd60013ecb300e461aef.svg";